function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnknownIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 18,
    rx: 6,
    ry: 6,
    style: {
      fill: "#292929",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.17,12.58s-.04,0-.05,0c-.15-.01-.29-.07-.41-.15-.04-.03-.08-.06-.11-.1-.11-.13-.18-.3-.18-.48h0V7.59c0-.41,.34-.75,.75-.75s.75,.34,.75,.75v2.43l4.38-4.38c.29-.29,.77-.29,1.06,0s.29,.77,0,1.06l-4.38,4.38h2.43c.41,0,.75,.34,.75,.75s-.34,.75-.75,.75h-4.24Z",
    style: {
      fill: "#fff"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknownIn);
export default __webpack_public_path__ + "static/media/unknown_in.70571affc2ffefa1529643f3f2c53fe7.svg";
export { ForwardRef as ReactComponent };